import { v4 as uuid } from 'uuid';
export function isFileWithUid(file) {
    return typeof file.uid === 'string';
}
export function fileEnsureUid(file) {
    if (isFileWithUid(file)) {
        return file;
    }
    Object.assign(file, { uid: uuid() });
    return file;
}
/**
 * Download a file
 * @param stringContent String to be converted to a blob and downloaded
 * @param filename Filename to use for the download
 * @param contentType Content type of the file
 *
 * @returns True if the file was downloaded successfully, false otherwise
 */
export function downloadFileFromString(stringContent, filename, contentType = 'text/plain;charset=utf-8') {
    try {
        const blob = new Blob([stringContent], { type: contentType });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        return true;
    }
    catch (error) {
        console.error('Error downloading file', error);
        return false;
    }
}
